import { RoutesPaths } from "../../../constants/routes.ts"

export type ProjectRowActionRoute = "edit" | "manage"

/**
 * Where a project row's "Edit Details" / "Manage" menu items navigate.
 *
 * Manage takes the workspace's index route rather than a named tab: the index
 * redirects to the first tab the user can actually see, so a menu item gated
 * on `project_edit` cannot land someone on a tab gated on a right they lack.
 * Naming `milestones` here would do exactly that.
 */
export const projectRowActionRoute = (
  action: ProjectRowActionRoute | (string & {}),
  id: string
): string | undefined => {
  switch (action) {
    case "edit":
      return RoutesPaths.project.edit(id)
    case "manage":
      return RoutesPaths.project.view(id)._layout
  }
}
